// extracted by mini-css-extract-plugin
export default {"FacetHelp":"xq_a bhj_jh bhj_sy","FacetHelp__paragraph":"xq_b bhj_vr bhj_xe","FacetHelp__youtube":"xq_c"};